<template>
  <div class="content">
    <div class="col-md-8 flex-container-top">
      <h2 class="text-eveer">City List</h2>
      <base-button
        type="primary"
        round
        icon
        class="top-button"
        @click="$router.push('add?id=-1')"
      >
        <i class="fa fa-plus"></i>
      </base-button>
    </div>
    <!--  <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">City List</h2>
    </div> -->
    <div class="row mt-2">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title">City List</h4>
          <div>
            <!-- <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary mb-3 pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <base-input>
                <el-input
                  type="search"
                  class="mb-3 search-input"
                  clearable
                  prefix-icon="el-icon-search"
                  placeholder="Search records"
                  v-model="searchQuery"
                  aria-controls="datatables"
                >
                </el-input>
              </base-input>
            </div> -->
            <el-table :data="queriedData">
              <el-table-column :min-width="200" align="left" label="City Name">
                <div slot-scope="props">
                  <div style="display: flex">
                    <div>
                      <div>{{ props.row.name }}</div>
                    </div>
                  </div>
                </div>
              </el-table-column>

              <el-table-column :min-width="200" align="right">
                <div slot-scope="props">
                  <base-button
                    @click="deleteCity(props.row)"
                    class="btn btn-fill"
                  >
                    <i
                      class="far fa-trash-alt"
                      style="color: red; margin-left: 10%"
                    />
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <!-- <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div> -->
        </card>
      </div>
    </div>

    <div class="row loader-pos">
      <div class="sk-chase" v-if="loading">
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
      </div>

      <div class="no-data-message" v-if="noDataMessage">
        <div>There are no records found</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "src/components";
import Fuse from "fuse.js";
import swal from "sweetalert2";
import { Modal, BaseAlert } from "src/components";

export default {
  components: {
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Modal,
    BaseAlert
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      console.log("hello");
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        console.log(this.searchedData);
        console.log("search data ");
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      noDataMessage: "",
      loading: false,
      modals_classic: false,
      actions: [],
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: "",
      propsToSearch: ["name"],
      tableColumns: [
        {
          prop: "name",
          label: "Name",
          minWidth: 200
        }
      ],
      tableData: [],
      tableDatas: [],
      searchedData: [],
      fuseSearch: null,
      currentOrder: {}
    };
  },

  async mounted() {
    this.fuseSearch = new Fuse(this.tableDatas, {
      keys: ["name"],
      threshold: 0.3
    });
    this.loading = true;
    let city = await this.$apiService.getCall("city/getcity");
    console.log("city Data");
    console.log(city);
    this.tableDatas = city.apidata.Data || [];
    this.tableData = this.tableDatas.reverse();
    console.log(this.tableData);
    this.loading = false;
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      console.log("search ");
      console.log(value);
      console.log(this.searchQuery);
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    }
  },
  methods: {
    async deleteCity(cityInfo) {
      console.log(cityInfo);
      this.loading = true;
      let deleteRes = await this.$apiService.postCall(
        "city/delete/" + cityInfo._id
      );

      let cityRes = await this.$apiService.getCall("city/getcity");
      console.log("city Data");
      console.log(cityRes);
      this.tableDatas = cityRes.apidata.Data || [];
      this.tableData = this.tableDatas.reverse();
      console.log(this.tableData);
      this.loading = false;
    }
  }
};
</script>
<style>
.pagination-select,
.search-input {
  width: 200px;
}
.swal2-icon-content {
  font-size: inherit !important;
}
</style>
